
/**
 * The google analytics utillity file contains support for connecting to the TEALIUM client.
 *
 * @module utils/tealium
 */


/**
 * Event handler for tealium integration for "view" events
 *
 * @method
 * @property { object } eventData - the analytics data object that should be formatted
 */
const triggerViewEvent = ( eventData, tealium = global.utag ) => {
  global.utag_data = { ...global.utag_data, ...eventData }
  tealium.view( global.utag_data, tealiumProcessor.handlePageViewEvents );
}


/**
 * Event handler for tealium integration for "link" events
 *
 * @method
 * @proeprty { object } eventData - tye analytics data object that should be formatted
 * @proeprty { function } handleInteractionEvents - call back method that needs to be invoked after triggering the events to tealium
 */
const triggerInteractionEvent = ( eventData, handleInteractionEvents, tealium = global.utag ) => {

  handleInteractionEvents ? tealium.link( eventData, handleInteractionEvents ) : tealium.link( eventData );
}


/**
 * This method holds the logic to trigger the event when utag object is ready and
 * queue events if it is not ready
 * @param  {Object} data
 */
const triggerEvent = ( data ) => {
  let { category, dataLayer, ...rest } = data;
  if( tealiumProcessor.isEventReady( data ) ){
    switch ( category?.toLowerCase() ){
      case 'view':
        triggerViewEvent( dataLayer );
        break;
      case 'interaction':
        triggerInteractionEvent( dataLayer, rest.handleInteractionEvents );
        break;
      default:
        console.error('triggerEvent: an event type was not defined');//eslint-disable-line
        break;
    }
  }
  else {
    queueAndProcessEvents( data );
  }
}

/**
 * This method is to process all the events in the queue
 */
const processQueuedEvents = () => {
  let event = tealiumProcessor.tealiumQueue.shift();
  while ( event ){
    triggerEvent( event );
    event = tealiumProcessor.tealiumQueue.shift();
  }
}

/**
 * This method is to queue and process the events from the
 * queue based on the presence of utag object
 * @param  {Object} data
 */
const queueAndProcessEvents = ( data ) => {
  tealiumProcessor.tealiumQueue.push( data );
  // handleInteractionEvents is a method that sets the flag to indicate datcapture event is pushed to the tealiumQueue
  if( data?.handleInteractionEvents ){
    data.handleInteractionEvents();
  }
  const triggerResolution = setInterval( function(){
    // TODO: Change this logic to be based on the unresolved data
    if( tealiumProcessor.isEventReady( data ) ){
      processQueuedEvents();
      clearInterval( triggerResolution );
    }
  }, 100 );
}


/** *
 * This method has the eligibility criteria based on which Tealium events needs to be triggered
 * This checks both for utag object to be present and onetrust is loaded (a valid string needs to be
 * present in the OnetrustActiveGroups variable)
 *
 */
const isTealiumReady = ( ) => {
  return ( global.utag && ( global.OnetrustActiveGroups && /[A-Za-z0-9]/.test( global.OnetrustActiveGroups ) ) );
}

/**
* This method has the eligibility criteria based on which Tealium events needs to be triggered
* This checks if the page view event is triggered before the other datacapture events are triggered and
* invoke isTealirmReady method to check both for utag object to be present and onetrust is loaded (a valid string needs to be
* present in the OnetrustActiveGroups variable)
* @param  {Object} data
*/
const isEventReady = ( data ) =>{
  return isTealiumReady() && ( data?.category?.toLowerCase() === 'view' || global.isPageEventViewTriggered ) ;
}

/*
* This call back method has triggered once the page view event is triggered.
* It sets a global variable to indicate the page view event is triggered
*
*/
const handlePageViewEvents = () =>{
  global.isPageEventViewTriggered = true ;
}

const tealiumProcessor = {
  tealiumQueue: [],
  triggerEvent,
  isTealiumReady,
  triggerInteractionEvent,
  handlePageViewEvents,
  isEventReady
}

export default tealiumProcessor;